import React from "react";
import { connect } from "react-redux";
import { callService, goTo } from "../tools";
import Datos from "./datos.cmpt";
import Seguridad from "./seguridad.cmpt";
import ContratoDatos from "./contrato-datos.cmpt";
import Bienvenido from "../contrato/bienvenido.cmpt";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const mapState = (state) => {
	return {
		paso: state.registroAF.paso
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnCerrar });
		},
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", "paso": 0 });
		},
		loginAccesoFamiliar: (sEmail) => {
			dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": sEmail });
		},
		altaHash: (hashOne, hashTwo, sEmail) => {
			dispatch({ "type": "REGISTRO_FAMILIAR_HASH", "hashOne": hashOne, "hashTwo": hashTwo });
			dispatch({ "type": "REGISTRO_FAMILIAR_EMAIL", "email": sEmail });
		},
		limpiarRegistro: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_LIMPIAR" });
		}
	};
};

class Flujo extends React.Component {

	state = {
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
	}

	login = () => {
		this.props.loginAccesoFamiliar(this.props.email);
		goTo("login?accesoFamiliar=" + this.props.email);
	}

	cerrar = () => {
		const $this = this;
		$this.props.loader(true);
		goTo("login");
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
		this.cerrar();
	}

	componentWillMount = () => {
		let $this = this;

		$this.props.loader(true);
		$this.props.siguientePaso();

		if (this.props.hashOne && this.props.hashTwo && this.props.email) {
			$this.props.altaHash(this.props.hashOne, this.props.hashTwo, this.props.email);
			new callService({
				service: "accesoFamiliar.validarInvitacion",
				secure: true,
				data: {
					hashOne: this.props.hashOne,
					hashTwo: this.props.hashTwo,
					email: this.props.email
				}
			}).execute().then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.props.loader(false);
			}).catch((error) => {
				console.log("Error", error);
				$this.props.loader(false);
				this.muestraTooltip(true, 'error', "ERROR", error.message.mensaje);
				setTimeout(() => {
					this.cierraTooltip();
				}, 5000);
			});
		} else {
			$this.props.loader(false);
			this.muestraTooltip(true, 'error', "ERROR", error.message.mensaje);
			setTimeout(() => {
				this.cierraTooltip();
			}, 5000);
		}
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro-familiar")) {
			main.style.width = "1250px";
		}
	}

	render() {
		return (
			<div className="gnpRegistro">

				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>

				{this.props.paso == 0 &&
					<div>
						<div id="title-Registro">
							<label id="txt-Registro">Datos Personales</label>
							<br />
							<hr className="label-hr" />
						</div>
						<Datos />
					</div>
				}
				{this.props.paso == 1 &&
					<div style={{ width: 1200 }}>
						<div id="title-Registro">
							<label id="txt-Registro">Datos de Seguridad</label>
							<br />
							<hr className="label-hr" />
						</div>
						<Seguridad />
					</div>
				}
				{this.props.paso == 2 &&
					<ContratoDatos />
				}
				{this.props.paso == 3 &&
					<Bienvenido />
				}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/flujo.cmpt.js